<template>   
<div style="position: relative;" class="py-2">
  <v-btn @click="downloadImage()" v-if="url" style="right: 20px;top:-20px;position: absolute;" small icon :title="$t('Pilot.Graphics.SaveConfigTooltip')"  ><v-icon >mdi-content-save</v-icon></v-btn>
  <div v-if="url === 0" style="min-height: 100px;" >        
    <div class="flex flex-col items-center justify-center w-full h-full mt-4" style="position: absolute;min-height: 100px;">
        <span v-if="cycle == 'all'" style="background-color: #fff;"  class="pa-2">                  
        {{ $t("Pilot.Images.LoadingAllCycle") }}
      </span>
      <span v-else style="background-color: #fff;" class="pa-2">          
        {{$t("Pilot.Images.LoadingCycle")}} {{cycle}}
      </span>        
      <v-progress-circular indeterminate color="primary" class="mt-2" ></v-progress-circular> 
    </div>        
    <img v-if="lastUrl" width="100%" :src="lastUrl"  />      
  </div>    
  <img v-else-if="url" width="100%" :src="url"  />      
  <div v-else  class="w-full flex justify-center align-center pa-4">
    <span>{{$t('Pilot.Ad2cp.NoDataAvailable')}}</span>
  </div>               
</div>
</template>

<script lang="ts">
  import Vue from 'vue'
  //@ts-ignore
  import Component from 'vue-class-component'
  import deepEqual from 'deep-equal'  
  import { Watch} from 'vue-property-decorator'
  import { MissionUi } from '@/models/ui/MissionUi';  
  import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer';
  import { IAd2cpConfig, getDefaultAd2cpConfig } from '@/models/iris/ad2cp/IAd2cpConfig';
  import { VuetifyConfirmObject } from 'vuetify-confirm'
  import apiMission from '@/api/mission'    
  import { buildMissionUIStateId } from '@/models/ui/MissionUiState';


  @Component({
    name: 'MissionDetailImage',
    props: {
      cycle: {
        type: String,
        required: true
      },
      pic:{
        type: Number,
        required: true,
        default: 1
      },
      misId:{
        type: Number,
        required: true        
      }
    }
  })
  export default class MissionDetailImage extends Vue {  
        
          
    get currentDetailMission(){
      return this.$store.myGetters.currentDetailMission
    }

    refresh = false
    lastUrl = false
    cycle!:string
    pic!:number
    misId!:number


    loadImageUrl() {                        
      const cacheKey = `irisimgcache_${this.misId}_${this.cycle}`
      const cacheImgKey = `${this.pic}`
      //@ts-ignore
      if(!window[cacheKey]) window[cacheKey] = {}            
      //@ts-ignore
      if(window[cacheKey][cacheImgKey] == undefined) {
        //@ts-ignore
        window[cacheKey][cacheImgKey] = 0
        apiMission.getIrisImageMission(this.misId,this.cycle,this.pic).then((response) => {
          //@ts-ignore
          window[cacheKey][cacheImgKey] = window.URL.createObjectURL(new Blob([response.data]))          
          this.refresh = !this.refresh
          //@ts-ignore
          this.lastUrl = window[cacheKey][cacheImgKey]
        }).catch((error) => {
          //@ts-ignore
          window[cacheKey][cacheImgKey] = false
          this.refresh = !this.refresh
          this.lastUrl = false
        })
      }
      else{
        //@ts-ignore
        this.lastUrl = window[cacheKey][cacheImgKey]
      }      
    }

    get url() {       
       this.refresh;
       const cacheKey = `irisimgcache_${this.misId}_${this.cycle}`
       const cacheImgKey = `${this.pic}`
      //@ts-ignore
      return window[cacheKey] && window[cacheKey][cacheImgKey]
    }

    get refreshPicture(){
      return this.$store.myGetters.refreshPicture
    }
    
    
    mounted() {
      this.loadImageUrl()
    }    
   
    get mission() {
        return this.currentDetailMission.mission
    }

    downloadImage() {
      const cacheKey = `irisimgcache_${this.misId}_${this.cycle}`
      const cacheImgKey = `${this.pic}`
      //@ts-ignore
      if(window[cacheKey] && window[cacheKey][cacheImgKey]){
        const a = document.createElement('a');
        //@ts-ignore
        a.href = window[cacheKey][cacheImgKey];
        a.download = `${this.mission.misLibelle}_${this.cycle}_pic${this.pic}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    }

    @Watch('cycle')
    onCurrentCycleChanged(newValue: any) {   
      this.loadImageUrl()                           
    }


    @Watch('misId')
    onMissionChanged(newValue: any) {   
      this.loadImageUrl()                           
    }

    @Watch('refreshPicture')
    onRefreshPictureChanged(newValue: any) {   
      this.loadImageUrl()                           
    }
    
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .subheading,.body-2{
    font-weight: bold;  
  }

  .flex-container{
    display:flex;
    flex-direction:column;
    position:relative;
  }

</style>
